import TubCommon from "./tubCommon";

export default class WalkInTub extends TubCommon {
  constructor(isChild) {
    super(isChild);
    this.partId = 'walk_in_tub';
    this.bottomTubId = "walk_in_tub";
    this.visible = true;
    this.partName = 'Walk In Tub';
    this.translateId = "visualizer.bathroom.shower_tub_combo.walk_in_tub";
    this.isStoneFeature = false;
    if (isChild) {
      this.oneLayerPosition = true;
    }
  }

  load(dbFeature) {
    dbFeature.metaData["layerPosition"] = dbFeature.metaData["Side"] ? dbFeature.metaData["Side"][0] : "";
    return super.load_(dbFeature, new WalkInTub());
  }

  navigationSubItems(filters, searchText) {
    return this.navigationSubItemsWithSides(filters, searchText);
  }

  setZIndex(zIndexes) {
    const zIndex = zIndexes.Shower.TubCombo.WalkInTub;
    if (zIndexes && this.activeFeature) {
      this.activeFeature.layer.zIndex = zIndex;
    }
    if (zIndexes && this.placeholderFeature) {
      this.placeholderFeature.layer.zIndex = zIndex;
    }
  }

}
